import {
  Modal,
  NavigationConfig,
  registerModals,
  registerNavigationHandlers,
} from '@betty/navigation';
import QuestsScreen from '../screens/QuestsScreen';
import QuestDetailsScreen from '../screens/QuestDetailsScreen/QuestDetailsScreen';
import { registerBottomSheets, BottomSheetComponent } from '@betty/navigation';
import QuestsInGameBottomSheet from './QuestsInGameBottomSheet';
import AbandonQuestBottomSheet from './AbandonQuestBottomSheet';
import SelectGameModal from './SelectGameModal/SelectGameModal';
import { ComponentProps, JSXElementConstructor } from 'react';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'Quests',
      options: {},
      component: QuestsScreen,
    },
    {
      name: 'QuestDetails',
      options: {},
      component: QuestDetailsScreen,
    },
  ],
  FULL_SCREEN_MODALS: [
    {
      name: 'SelectGameModal',
      options: {},
      component: SelectGameModal,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheet = {
  default: QuestsInGameBottomSheet,
  abandon: AbandonQuestBottomSheet,
};

registerBottomSheets('quests', bottomSheet);

registerNavigationHandlers<
  AppNavigatorParamsList,
  'Quests' | 'QuestDetails' | 'SelectGameModal'
>({
  Quests(navigate) {
    navigate('/quests');
  },
  QuestDetails(navigate, params) {
    if (!params) {
      return;
    }
    const { id } = params;

    navigate(`/quests/${id}`);
  },
  SelectGameModal(_, { questId, filterGames }) {
    Modal.open({
      namespace: 'quests',
      type: 'SelectGameModal',
      data: {
        route: {
          params: { questId, filterGames },
        },
      },
    });
  },
});

declare global {
  interface RegisteredBottomSheets {
    quests: Record<keyof typeof bottomSheet, BottomSheetComponent>;
  }
}

const modals = {
  SelectGameModal: SelectGameModal,
};

registerModals('quests', modals);
declare global {
  interface RegisteredModals {
    quests: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
